import { Flex, font, themedColor } from '@lemonade-hq/cdk';
import { I18nContext } from '@lemonade-hq/nuiza';
import parse from 'html-react-parser';
import Image from 'next/image';
import { rgba } from 'polished';
import type React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

const SHADOW_OPACITY_1 = 0.06;
const SHADOW_OPACITY_2 = 0.16;

const TweetCardCmp = styled(Flex)<{ readonly shortCard: boolean }>`
  background: ${themedColor('white')};
  height: ${({ shortCard }: { readonly shortCard: boolean }) => (shortCard ? '200px' : '255px')};
  width: 338px;
  box-shadow:
    0 1px 8px 0 ${({ theme }) => rgba(theme.colors.black, SHADOW_OPACITY_1)},
    0 31px 30px -18px ${({ theme }) => rgba(theme.colors.black, SHADOW_OPACITY_2)};
  border-radius: 10px;
  padding: 20px;
  box-sizing: content-box;
  p {
    ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })}
  }

  &.tweet-card {
    min-height: 0;
  }
`;

const TweetImage = styled(Image)`
  width: 5.4rem;
  height: 5.4rem;
  padding: 2px;
  position: relative;
  top: -5px;
  border-radius: 50%;
`;

const Name = styled.p`
  text-align: left;
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem', fontWeight: 700 })};
`;

const Handle = styled.p`
  text-align: left;
  ${font('main', { fontSize: '1.4rem', lineHeight: '2.2rem', fontWeight: 700 })};
  color: ${themedColor('metal')};
`;

const TweetText = styled.p`
  text-align: left;
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.4rem' })}

  .primary {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export interface Tweet {
  readonly img: StaticImageData | string;
  readonly handle: string;
  readonly name: string;
  readonly text?: string;
}

interface TweetCardProps {
  readonly tweet: Tweet;
  readonly className?: string;
  readonly shortCard?: boolean;
}

export const TweetCard: React.FC<TweetCardProps> = ({ tweet, className = '', shortCard = true }) => {
  const { img, handle, name, text } = tweet;
  const { s } = useContext(I18nContext);

  return (
    <TweetCardCmp className={`tweet-card ${className}`} flexDirection="column" m="15px" p="20px" shortCard={shortCard}>
      <Flex flexDirection="row">
        <TweetImage alt={handle} src={img} />
        <Flex flex="1" flexDirection="column" pl="10px">
          <Name>{name}</Name>
          <Handle>{handle}</Handle>
        </Flex>
      </Flex>
      <TweetText>{parse(text ?? s(`hp.customer_reviews.tweets.${handle}`))}</TweetText>
    </TweetCardCmp>
  );
};
